import type { ExtractPreviewResponse } from '@/shared/hooks/api/userStandards'
import {
  ExtractionPreviewImpedimentBanner,
  ExtractionPreviewNoData,
  ExtractionPreviewSectionNotFound,
  type SectionExtractionPreviewContentProps,
} from './standardExtractionPreviewShared'

type StandardScopeExtractionPreviewContentProps =
  SectionExtractionPreviewContentProps & {
    preview: ExtractPreviewResponse
  }

export function StandardScopeExtractionPreviewContent({
  preview,
  uiState,
  resolveReason,
  translate,
}: StandardScopeExtractionPreviewContentProps) {
  const scope = preview.scope?.trim() ?? ''
  const hasScope = scope.length > 0
  const sectionNotFound = uiState.sectionNotFound
  const sectionImpediment = uiState.sectionImpediment

  if (hasScope) {
    return (
      <div className='text-sm leading-loose whitespace-pre-wrap'>{scope}</div>
    )
  }
  if (sectionNotFound) {
    return (
      <ExtractionPreviewSectionNotFound
        reasonCode={sectionImpediment?.reason ?? 'scope_not_found'}
        resolveReason={resolveReason}
        translate={translate}
      />
    )
  }
  if (sectionImpediment != null) {
    return (
      <ExtractionPreviewImpedimentBanner
        label={translate('detail.extractPreview.noScopeExtracted')}
        reason={resolveReason(sectionImpediment.reason)}
      />
    )
  }
  return <ExtractionPreviewNoData translate={translate} />
}
